var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.description),function(item){return _c('li',{key:item},[_c('IxRes',[_vm._v(_vm._s(("dlgCert.ecology.descriptions.landscapeDescription." + ([item]))))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }